import { Button } from "@mui/material";
import { useState } from "react";

import { claimResources } from "../store";
import type {
  ResourceObjects,
  TokenValleyBlockType,
} from "../types/tokenValley";
import { getResourceGatheringIconBlockTypes } from "../utils/getResourceGatheringIcon";

const ResourceGatheringButton = ({
  activeBlock,
  setResourceGatheringButton,
}: {
  activeBlock: TokenValleyBlockType;
  setResourceGatheringButton: (resourceGathering: ResourceObjects) => void;
}) => {
  const [disabled, setDisabled] = useState(false);
  const resourceGathering = Object.keys(
    activeBlock.resource_stock,
  )[0] as ResourceObjects;

  const handleClickOpen = () => {
    setDisabled(true);
    setResourceGatheringButton(resourceGathering);
    claimResources({ resource_name: resourceGathering });
    setTimeout(() => {
      setDisabled(false);
    }, 500);
  };

  return (
    <Button onClick={handleClickOpen} variant="brown" disabled={disabled}>
      <img
        src={getResourceGatheringIconBlockTypes(activeBlock.block_type) ?? ""}
        alt=""
        style={{ width: "25px", marginRight: "5px" }}
      />
      Claim
    </Button>
  );
};

export default ResourceGatheringButton;
